/**
 * NOS-5: Reusable text input for builder UI.
 * All specs from docs/specs/BUILDER_DESIGN_SPEC.md Section 11.
 */
import type { InputHTMLAttributes, TextareaHTMLAttributes } from "react"

const inputBaseStyles: React.CSSProperties = {
  width: "100%",
  padding: "8px 10px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: 8,
  color: "#fff",
  fontSize: 12,
  fontFamily: "'DM Sans', sans-serif",
  lineHeight: 1.5,
  boxSizing: "border-box",
  outline: "none",
}

export interface TinyInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "style"> {
  /** Multiline variant: renders textarea with min-height 64px */
  multiline?: boolean
  style?: React.CSSProperties
}

export function TinyInput({
  multiline = false,
  style,
  value,
  onChange,
  ...props
}: TinyInputProps) {
  const combinedStyle = { ...inputBaseStyles, ...style }

  if (multiline) {
    return (
      <textarea
        {...(props as Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "value" | "onChange">)}
        value={value as string}
        onChange={onChange as unknown as React.ChangeEventHandler<HTMLTextAreaElement>}
        style={{
          ...combinedStyle,
          resize: "vertical",
          minHeight: 64,
        }}
      />
    )
  }

  return (
    <input
      type="text"
      {...props}
      value={value}
      onChange={onChange}
      style={combinedStyle}
    />
  )
}
